import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';

import { getFormValues } from 'redux/DataImportSlice';

import ActionStepSyncOptions from '../ActionStepSyncOptions';

import RowTypeSecondStep from './MultipleIndicatorType/RowTypeSecondStep';
import SelectDimensionColumn from './SelectDimensionColumn';

const DataStepsFive = () => {
  const getFormValue = useSelector(getFormValues);
  const activeActionStep = useSelector((state: any) => state.dataImportSlice.actionSteps);
  return (
    <Flex w={'full'}>
      {getFormValue?.multipleIndicatorsType === 'row' &&
        getFormValue?.dataPeriod === '2' &&
        getFormValue?.selectedTimePeriod === 'row' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 6 && <RowTypeSecondStep getFormValue={getFormValue} />}
      {getFormValue?.multipleIndicatorsType === 'row' &&
        getFormValue?.dataPeriod === '1' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 5 && <RowTypeSecondStep getFormValue={getFormValue} />}

      {getFormValue?.multipleIndicatorsType === 'column' &&
        getFormValue?.dataPeriod === '2' &&
        getFormValue?.selectedTimePeriod === 'row' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 6 && <SelectDimensionColumn getFormValue={getFormValue} />}
      {getFormValue?.multipleIndicatorsType === 'row' &&
        getFormValue?.dataPeriod === '2' &&
        getFormValue?.selectedTimePeriod === 'column' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 6 && <SelectDimensionColumn getFormValue={getFormValue} />}

      {getFormValue?.multipleIndicatorsType === 'column' &&
        getFormValue?.dataPeriod === '2' &&
        getFormValue?.selectedTimePeriod === 'column' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 6 && <SelectDimensionColumn getFormValue={getFormValue} />}

      {getFormValue?.multipleIndicatorsType === 'column' &&
        getFormValue?.dataPeriod === '1' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 5 && <SelectDimensionColumn getFormValue={getFormValue} />}

      {/* Sync Options — last step after SelectDimensionColumn for these flows */}
      {getFormValue?.multipleIndicatorsType === 'column' &&
        getFormValue?.dataPeriod === '2' &&
        getFormValue?.selectedTimePeriod === 'row' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 7 && <ActionStepSyncOptions actionType='data' />}
      {getFormValue?.multipleIndicatorsType === 'row' &&
        getFormValue?.dataPeriod === '2' &&
        getFormValue?.selectedTimePeriod === 'column' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 7 && <ActionStepSyncOptions actionType='data' />}
      {getFormValue?.multipleIndicatorsType === 'column' &&
        getFormValue?.dataPeriod === '2' &&
        getFormValue?.selectedTimePeriod === 'column' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 7 && <ActionStepSyncOptions actionType='data' />}
      {getFormValue?.multipleIndicatorsType === 'column' &&
        getFormValue?.dataPeriod === '1' &&
        getFormValue?.importIndicatorType === '2' &&
        activeActionStep === 6 && <ActionStepSyncOptions actionType='data' />}
    </Flex>
  );
};

export default DataStepsFive;
